import type {TrackingEvent} from '@/redux/middleware/googleTagManager/types';

import {wrappedFunctionToWaitForGtmDom} from '@/redux/middleware/googleTagManager/utils/waitForGtmDomEvent';

export const genericEventHandler = wrappedFunctionToWaitForGtmDom(
  (event: TrackingEvent) => event.payload
);
